// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors.e6f95c0a51efd674c423.bundle.js";
	// return url for filenames based on template
	return "" + chunkId + ".chunk.bundle.js";
};